<script>
import { REPORT_PALETTE } from '@modules/consolidator/constants/Color'
import { WALLET_EMPTY_MESSAGE } from '@modules/consolidator/constants/Text'
import { getCurrencyByInvestmentType } from '@modules/consolidator/utils/InvestmentType/InvestmentType.js'
import { formatBarsHorizontal_v2 } from '@utils/GraficoData'
import { truncateText } from '@utils/Format'
import FeedbackWrapper from '@modules/global/components/feedback-wrapper/feedback-wrapper.vue'

export default {
  name: 'Distribuicao',
  components: { FeedbackWrapper },
  props: {
    distribuicaoPor: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    investmentType: {
      type: String,
      default: '',
    },
    minHeight: {
      type: [String, Number],
      default: 400,
    },
    maxItems: {
      type: Number,
      default: 7,
    },
  },
  data() {
    return {
      PALETA: REPORT_PALETTE,
      WALLET_EMPTY_MESSAGE,
      heightPerItem: 46,
      minChartHeight: 280,
      maxVisibleHeight: 360,
      showLabelEndOfBar: true,
      datasetLabel: 'Valor',
      axisLabelMaxLength: 20,
    }
  },
  computed: {
    title() {
      return this.distribuicaoPor
        ? `Distribuição por ${this.distribuicaoPor}`
        : 'Distribuição'
    },
    sortedItems() {
      return Object.values(this.data)
        .filter((item) => item && item.percent > 0)
        .map((item) => ({
          label: item.name,
          percent: item.percent,
          value: item.value,
        }))
        .sort((a, b) => b.percent - a.percent)
    },
    hasNoData() {
      return this.sortedItems.length === 0
    },
    topItems() {
      const top = this.sortedItems.slice(0, this.maxItems)
      const outros = this.sortedItems.slice(this.maxItems)
      if (outros.length) {
        top.push({
          label: 'Outros',
          percent: outros.reduce((sum, item) => sum + item.percent, 0),
          value: outros.reduce((sum, item) => sum + item.value, 0),
        })
      }
      return top
    },
    currency() {
      return getCurrencyByInvestmentType({
        investmentType: this.investmentType,
      })
    },
    horizontalChart() {
      const values = this.topItems.map((item) => item.value)
      const dados = {
        mode: 'monetario',
        currency: this.currency,
        legend: false,
        data: {
          labels: this.topItems.map((item) => item.label),
          datasets: {
            [this.datasetLabel]: {
              dados: values,
              colors: this.topItems.map(
                (_, index) => this.PALETA[index % this.PALETA.length]
              ),
              porcentagens: this.topItems.map((item) => item.percent / 100),
              rawValues: values,
              mode: 'monetario',
            },
          },
        },
      }
      const chart = formatBarsHorizontal_v2(dados, this.showLabelEndOfBar)
      const yAxes =
        chart.chartOptions &&
        chart.chartOptions.scales &&
        chart.chartOptions.scales.yAxes
      if (yAxes && yAxes[0] && yAxes[0].ticks) {
        yAxes[0].ticks.callback = (label) =>
          truncateText({
            text: label == null ? '' : String(label),
            maxLength: this.axisLabelMaxLength,
          })
      }
      return chart
    },
    chartHeight() {
      return Math.max(
        this.minChartHeight,
        this.topItems.length * this.heightPerItem
      )
    },
    chartScrollStyle() {
      if (this.chartHeight <= this.maxVisibleHeight) return {}
      return {
        maxHeight: `${this.maxVisibleHeight}px`,
        overflowY: 'auto',
      }
    },
  },
}
</script>

<template>
  <div
    class="distribuicao az-card-bordered"
    :class="{ 'distribuicao--loading': loading }"
  >
    <div
      v-if="!loading"
      class="distribuicao__title az-ds-card-title"
    >
      {{ title }}
    </div>

    <FeedbackWrapper
      :loading="loading"
      :noData="hasNoData"
      :message="WALLET_EMPTY_MESSAGE"
      :minHeight="minHeight"
    >
      <div class="distribuicao__chart-scroll" :style="chartScrollStyle">
        <div :style="{ height: chartHeight + 'px' }">
          <bar-horizontal-chart
            :chart-data="horizontalChart.chartData"
            :options="horizontalChart.chartOptions"
            :plugins="horizontalChart.chartPlugins"
            :height="chartHeight"
          />
        </div>
      </div>
    </FeedbackWrapper>
  </div>
</template>

<style lang="sass">
.distribuicao
  height: 100%
  padding-bottom: 32px

  &--loading
    padding: 0 !important

    .feedback-wrapper > div
      height: 100% !important
      width: 100% !important

  &__chart-scroll
    margin-top: 16px
</style>
